import React, { createContext, useReducer } from 'react'

export const TABS = {
  PRIVATE: 'PRIVATE',
  PUBLIC: 'PUBLIC',
  BOOKMARKED: 'BOOKMARKED'
}

export const ACTION_TYPES = {
  UPDATE_TAB: 'UPDATE_TAB',
  UPDATE_QUERY: 'UPDATE_QUERY',
  UPDATE_FILTER: 'UPDATE_FILTER',
  UPDATE_FILE: 'UPDATE_FILE'
}

export const FinderStateContext = createContext()
export const FinderDispatchContext = createContext()

const reducer = (state, action) => {
  switch (action.type) {
    case ACTION_TYPES.UPDATE_TAB:
      return { ...state, tab: action.payload }
    case ACTION_TYPES.UPDATE_QUERY:
      return { ...state, query: action.payload }
    case ACTION_TYPES.UPDATE_FILTER:
      return { ...state, filter: action.payload }
    case ACTION_TYPES.UPDATE_FILE:
      return { ...state, file: action.payload }
    case ACTION_TYPES.UPDATE_OVERSIZE:
      return { ...state, oversize: action.payload }
    default: {
      throw new Error(`Unhandled action type: ${action.type}`)
    }
  }
}

export const FinderProvider = ({ mode, children }) => {
  const [state, dispatch] = useReducer(reducer, {
    tab: TABS.PRIVATE,
    query: '',
    filter: { participants: [], type: '' },
    file: null,
    mode,
    oversize: null
  })

  return (
    <FinderStateContext.Provider value={state}>
      <FinderDispatchContext.Provider value={dispatch}>
        {children}
      </FinderDispatchContext.Provider>
    </FinderStateContext.Provider>
  )
}

export default FinderProvider
